import { render } from "./CodeCheck.vue?vue&type=template&id=85baaa84&scoped=true"
import script from "./CodeCheck.vue?vue&type=script&lang=js"
export * from "./CodeCheck.vue?vue&type=script&lang=js"

import "./CodeCheck.vue?vue&type=style&index=0&id=85baaa84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85baaa84"]])

export default __exports__